import { lazy } from 'react';
import { lazyRetry } from '../../utils/general';
const Alert = lazy(() => lazyRetry(() => import('./Alert')));
export { Alert };
